"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Button = styled_components_1.default.button `
  color: ${(props) => props.theme.colors.greyBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  cursor: pointer;
  width: 100%;
  position: relative;
  display: block;
  font-size: 1rem;
  text-align: center;
  text-decoration: none !important;
  padding: ${({ theme }) => theme.spacings.xs}
    ${({ theme }) => theme.spacings.m};
  transition: ${({ theme }) => theme.utils.transition.default};
  border: 1px solid transparent;
  outline: none;

  &:disabled {
    cursor: not-allowed;
  }

  &:before {
    content: " ";
    display: inline-block;
  }
`;
//# sourceMappingURL=button.js.map